import { DOUBLE_X_SKU } from '@/utils/constants';

function parseSeq(str) {
  return str.split(',').map((x) => parseInt(x, 10));
}

function genProductGroupsByFunctionality(groupTypes, productsGroupByCategory) {
  const arr = [];
  groupTypes.forEach((n) => {
    const pg = {
      name: n.name,
      checked: true,
      groupCode: n.groupCode,
      items: productsGroupByCategory[n.groupCode].slice(0),
    };

    arr.push(pg);
  });

  return arr;
}

function getProductsFromSkus(products, skus) {
  return skus.map((n) => ({
    ...(products.find((n2) => n2.item_sku === n.item_sku)),
    count: n.count,
    seq: n.seq,
  }));
}

function reduceCountIfDoubleX(sku, count) {
  if (sku === DOUBLE_X_SKU) {
    return parseInt(count / 3, 10);
  }
  return count;
}

function restoreCountIfDoubleX(sku, count) {
  if (sku === DOUBLE_X_SKU) {
    return count * 3;
  }
  return count;
}

function splitBy1(selectedProducts) {
  const arrangedProducts = selectedProducts.map((n) => {
    const { count } = n;
    const min = n.item_sku === DOUBLE_X_SKU ? parseInt(count / 3, 10) : count;
    const max = min;
    return {
      ...n,
      min_tab: min,
      max_tab: max,
      selectedCount: count,
      seq: 1,
    };
  });

  const pg = {
    name: '하루',
    items: arrangedProducts,
  };
  return [pg];
}
function splitBy2(selectedProducts) {
  const prod1 = [];
  const prod2 = [];

  selectedProducts.forEach((n) => {
    const count = reduceCountIfDoubleX(n.item_sku, n.count);
    const half = Math.floor(count / 2);
    let seq1 = half;
    const seq2 = half;
    if (count % 2) {
      seq1 += 1;
    }
    const max = count;
    const p1 = {
      ...n,
      min_tab: 0,
      max_tab: max,
      selectedCount: restoreCountIfDoubleX(n.item_sku, seq1),
      seq: 1,
    };
    const p2 = {
      ...n,
      min_tab: 0,
      max_tab: max,
      selectedCount: restoreCountIfDoubleX(n.item_sku, seq2),
      seq: 3,
    };

    prod1.push(p1);
    prod2.push(p2);
  });

  const pg1 = {
    name: '오전',
    items: prod1,
  };
  const pg2 = {
    name: '오후',
    items: prod2,
  };

  return [pg1, pg2];
}

function resplitProductGroupsBy2(item, productGroups) {
  let targetPg;
  let sourcePg;
  if (item.seq === 1) {
    // eslint-disable-next-line prefer-destructuring
    targetPg = productGroups[1].items;
    sourcePg = productGroups[0].items;
  } else {
    // eslint-disable-next-line prefer-destructuring
    targetPg = productGroups[0].items;
    sourcePg = productGroups[1].items;
  }

  const p = targetPg.find((n) => n.item_sku === item.item_sku);
  const { count } = p;
  p.selectedCount = count - item.selectedCount;

  const s = sourcePg.find((n) => n.item_sku === item.item_sku);
  s.selectedCount = item.selectedCount;
}

function setSelectedCountGroupBy1(finalSkus, groups) {
  finalSkus.forEach((n) => {
    const seqs = n.seq.split(',').map((s) => parseInt(s, 10));
    // eslint-disable-next-line no-param-reassign
    let group = groups[0].items
      .find((n2) => n2.item_sku === n.item_sku)

    if (group) {
      group.selectedCount = restoreCountIfDoubleX(n.item_sku, seqs[0]);
    }
  });
}

function setSelectedCountGroupBy2(finalSkus, groups) {
  finalSkus.forEach((n) => {
    const seqs = n.seq.split(',').map((s) => parseInt(s, 10));
    // eslint-disable-next-line no-param-reassign
    let group1 = groups[0].items
      .find((n2) => n2.item_sku === n.item_sku)
    if (group1) {
      group1.selectedCount = restoreCountIfDoubleX(n.item_sku, seqs[0]);
    }
    // eslint-disable-next-line no-param-reassign
    let group2 = groups[1].items
      .find((n2) => n2.item_sku === n.item_sku)
    if (group2) {
      group2.selectedCount = restoreCountIfDoubleX(n.item_sku, seqs[2]);
    }
  });
}

function splitProductsByUnitTaken(products, pockets, selectedSkus, finalSkus) {
  const selectedProducts = getProductsFromSkus(products, selectedSkus);

  const n = typeof pockets === 'number' ? pockets.toString() : pockets;
  let groups = [];
  switch (n) {
    case '1':
      groups = splitBy1(selectedProducts);
      setSelectedCountGroupBy1(finalSkus, groups);
      break;
    case '2':
      groups = splitBy2(selectedProducts);
      setSelectedCountGroupBy2(finalSkus, groups);
      break;
    case '3':
      console.warn('3 dose count not supported');
      break;
    default:
      console.warn('unit taken is not set.');
      return [];
  }

  return groups;
}

function splitProductsByDoesGroup(products, finalProducts = [], pockets) {
  const productGroups = [];
  const pgs = {
    pg1: [],
    pg2: [],
    pg3: [],
  };

  finalProducts.forEach((n) => {
    const seqCounts = parseSeq(n.seq);
    // eslint-disable-next-line camelcase
    const product = products.find((f) => f.item_sku === n.item_sku);

    const itemHashes = product.explain.split('#').filter((n2) => n2.length > 0);
    for (let i = 0; i < 3; ++i) {
      pgs[`pg${i + 1}`].push({
        ...product,
        count: seqCounts[i],
        item_hashes: itemHashes,
      });
    }
  });
  switch (pockets) {
    case 1:
      productGroups.push({
        name: '하루',
        items: pgs.pg1,
      });
      break;
    case 2:
      productGroups.push({
        name: '오전',
        items: pgs.pg1,
      });
      productGroups.push({
        name: '오후',
        items: pgs.pg3,
      });
      break;
    case 3:
      // productGroups.push({
      //   name: '아침',
      //   items: pgs.pg1,
      // });
      // productGroups.push({
      //   name: '점심',
      //   items: pgs.pg2,
      // });
      // productGroups.push({
      //   name: '저녁',
      //   items: pgs.pg3,
      // });
      console.warn('3 dose count not supported.');
      break;
    default:
      console.warn(
        'pocket count is not currently set. maybe it causes a problem.',
      );
  }
  return productGroups;
}

function genProductGroupsByPocketCount(products, pockets, selectedSkus, finalSkus = []) {
  if (pockets > 0) {
    return splitProductsByUnitTaken(products, pockets, selectedSkus, finalSkus);
  }
  return [];
}

function genSequence(productGroups, pockets, index) {
  let s1; let s2; let s3;
  switch (pockets) {
    case 1:
      s1 = reduceCountIfDoubleX(
        productGroups[0].items[index].item_sku,
        productGroups[0].items[index].selectedCount,
      );
      s2 = 0;
      s3 = 0;
      break;

    case 2:
      s1 = reduceCountIfDoubleX(
        productGroups[0].items[index].item_sku,
        productGroups[0].items[index].selectedCount,
      );
      s2 = 0;
      s3 = reduceCountIfDoubleX(
        productGroups[1].items[index].item_sku,
        productGroups[1].items[index].selectedCount,
      );
      break;
    case 3:
      // s1 = productGroups[0].items[index].selectedCount;
      // s2 = productGroups[1].items[index].selectedCount;
      // s3 = productGroups[2].items[index].selectedCount;
      console.warn('3 dose count not supported');
      break;
    default: console.warn('something wrong in proceedNext');
  }
  return [s1, s2, s3].join(',');
}

function genFinalSkusFromProductPocketGroups(productGroups, days, pockets) {
  return productGroups[0].items.map((n, index) => ({
    item_sku: n.item_sku,
    seq: genSequence(productGroups, pockets, index),
    days,
    pockets,
  }));
}

function getSelectedSkusFromPack(pack) {
  return pack.pack_detail.map((n) => (
    {
      item_sku: n.item_sku,
      count: parseSeq(n.doseSeqs)
        .reduce((acc, cur) => acc + (n.item_sku === DOUBLE_X_SKU ? cur * 3 : cur),
          0),
    }
  ));
}


function getSoldoutProducts(products, finalProducts = [], soldoutSku = [], endOfSaleSku = []) {
  return [...soldoutSku, ...endOfSaleSku].flatMap((sku) =>
    finalProducts
      .filter((n) => n.item_sku === sku)
      .map((n) => ({
        ...(products.find((f) => f.item_sku === sku)),
        count: parseSeq(n.seq).reduce((acc, cur) => acc + cur, 0),
        status: soldoutSku.includes(sku) ? "soldout" : "endOfSale",
      }))
  );
}

export default {
  resplitProductGroupsBy2,
  getProductsFromSkus,
  genProductGroupsByFunctionality,
  genProductGroupsByPocketCount,
  splitProductsByDoesGroup,
  genFinalSkusFromProductPocketGroups,
  getSelectedSkusFromPack,
  parseSeq,
  getSoldoutProducts,
};



// WEBPACK FOOTER //
// ./src/utils/helpers/product.js